import { render, staticRenderFns } from "./examenFisico.vue?vue&type=template&id=7ef9a09e"
import script from "./examenFisico.vue?vue&type=script&lang=js"
export * from "./examenFisico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports